/**
 * What the Pipeline does when other tools' events arrive (it never calls them directly):
 * - meeting.held: the account's deals waiting on their demo ("Demo scheduled") move to
 *   "Demo completed", which suggests sending the agreement next.
 * Registered once per data provider; a newer provider replaces the older one's listeners.
 */
import type { Identifier } from "ra-core";

import { subscribe } from "./events";
import type { ZcrmDeal } from "./mappers";

/** The stage a held demo moves a deal out of, and into. */
export const DEMO_HELD_MOVE = {
  from: "demo_scheduled",
  to: "demo_completed",
} as const;

let unsubscribe: (() => void) | null = null;

export const registerPipelineListeners = ({
  dealsOf,
  moveDeal,
}: {
  dealsOf: (companyId: Identifier) => Promise<ZcrmDeal[]>;
  moveDeal: (deal: ZcrmDeal, stage: string) => Promise<unknown>;
}): void => {
  unsubscribe?.();
  unsubscribe = subscribe("meeting.held", async ({ companyId }) => {
    if (!companyId) return;
    const waiting = (await dealsOf(companyId)).filter(
      (deal) => deal.stage === DEMO_HELD_MOVE.from,
    );
    for (const deal of waiting) await moveDeal(deal, DEMO_HELD_MOVE.to);
  });
};
